import { ReactNode, useRef } from "react"
import { CSSTransition } from "react-transition-group"
import styles from "./styles.module.css"

export const Collapsible = ({ isOpen, children }: Props) => {
  const nodeRef = useRef(null)

  return (
    <CSSTransition in={isOpen} timeout={500} nodeRef={nodeRef}
      className={styles.collapsible} classNames={{...styles}} >
      <div ref={nodeRef}>
        {children}
      </div>
    </CSSTransition>
  )
}

interface Props {
  isOpen: boolean;
  children: ReactNode;
}
